/**
 * @file Contributor UI — publicationReadOnlyHelpers. Resolve a display string for publication functional-unit companion unit from API shapes. */

import { formatUnitSymbol } from "../../../../../../utils/formatUnitSymbol";

/** Exported function — publication Functional Unit Unit Display. */
export function publicationFunctionalUnitUnitDisplay(
  publication: Record<string, unknown> | null | undefined
): string {
  if (!publication) return "";
  const p = publication;
  const nested = p.functionalUnitUnit;
  if (nested && typeof nested === "object") {
    const o = nested as Record<string, unknown>;
    return formatUnitSymbol(
      firstNonEmptyString(
        o.symbol,
        o.unitSymbol,
        o.displayName,
        o.name,
        o.id
      )
    );
  }
  return formatUnitSymbol(
    firstNonEmptyString(
      p.functionalUnitUnit,
      p.functionalUnitUnitLabel,
      p.functionalUnitUnitSymbol,
      p.functionalUnitUnitName,
      p.functionalUnitUnitId,
      p.functional_unit_unit,
      p.functional_unit_unit_id
    )
  );
}

function firstNonEmptyString(...vals: unknown[]): string {
  for (const v of vals) {
    if (v == null) continue;
    const s = typeof v === "string" || typeof v === "number" ? String(v) : "";
    if (s.trim() !== "") return s;
  }
  return "";
}
